import React from 'react';
import classnames from 'classnames';
import {Button} from '@br/br-components';

import FbLoginButton from '../atoms/fbLoginButton';
import BrLogo from '../atoms/brLogo';
import {WarnerMedia} from '../../endpoints';

class ChooseSignupMethod extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onEmail = () => {
      this.trackEvent();
      this.props.methodChosen('email');
      this.props.stepCompleted();
    };
    this.onFacebook = () => {
      this.props.methodChosen('facebook');
      this.props.stepCompleted();
    };
    this.onPhone = () => {
      this.trackEvent();
      this.props.methodChosen('phone');
      this.props.stepCompleted();
    };
    this.onFbOauth = this.onFbOauth.bind(this);
    this.trackEvent = this.trackEvent.bind(this);
  }

  onFbOauth(payload) {
    this.props.onFbOauth(payload);
    this.onFacebook();
  }

  trackEvent() {
    const {returnUrl} = this.props;
    const app = returnUrl && returnUrl.includes('bracketchallenge') ? 'BCG' : 'BR';

    this.props.trackEvent({
      app,
      tag_manager_event: 'create_account',
    });
  }

  render() {
    const classes = classnames({
      molecule: true,
      chooseSignupMethod: true,
    });
    return (
      <div className={classes}>
        <BrLogo />
        <div className="legalText">
          <p className="onDarkBackground">
            By signing up, you agree to the terms and conditions of the Bleacher Report{' '}
            <a href="/pages/terms">Terms of Use</a> and{' '}
            <a href={WarnerMedia.privacy()}>Privacy Policy</a>.
          </p>
        </div>
        <Button classes="primary" onClick={this.onPhone}>
          Sign up with Phone
        </Button>
        {!this.props.disableFbSignup && (
          <FbLoginButton
            attemptFbLogin={this.onFbOauth}
            loadScript={this.props.loadScript}
            trackEvent={this.trackEvent}
            isSignup={true}
          >
            Sign up with Facebook
          </FbLoginButton>
        )}
        {this.props.showEmailSignup && (
          <Button classes="email" onClick={this.onEmail}>
            Sign up with Email
          </Button>
        )}
      </div>
    );
  }
}

ChooseSignupMethod.defaultProps = {
  returnUrl: '',
};

export default ChooseSignupMethod;
